import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';

// import {SellerTerms, TermsFormatter} from './_TermsContent.jsx';

export default class TermsSeller extends BLComponent {
		constructor (props, context) {
		super(props, context);

		this.state = {
			selectedTerms: -1,
			termsHistory: [],
			terms: null
		}

		// this.preview = blapp.util.getUrlVar('preview') ? true : false;
	}

	componentDidMount() {
		this.getTermsHistory();
	}

	render() {
		// const isPreviewTerms = SellerTerms().findIndex(item => item.preview == true) != -1;

		// const activeTerms = SellerTerms().filter(item => item.preview == false).sort((itemA, itemB) => itemA.updated > itemB.updated ? -1 : 1);
		// const terms = this.preview && isPreviewTerms ? SellerTerms()[SellerTerms().findIndex(item => item.preview == true)] : this.state.selectedTerms == -1 ? activeTerms[0] : activeTerms.find(terms => terms.id == this.state.selectedTerms);
		// const termsHistory = activeTerms.map(terms => <option value={terms.id}>{blapp.format.formatDate(terms.updated)}</option>);
		
		return (
			<div className="main l-margin-y--xxl l-border-round overflow-hidden">
				<div className="main__content l-pad--null">
					<header className="l-pad--xl l-border-bottom l-flex l-split">
						<div>
							<h1 className="text--xl-title">Seller Terms of Service</h1>
							{this.state.terms &&
							<p>Last updated: {blapp.format.formatDate(this.state.termsHistory[0])}{this.state.selectedTerms !== 0 && " – Viewing previous version"}</p>
							}
							{/* {this.preview ? 
								<p>New update: {blapp.format.formatDate(terms.updated)}</p>
							:
								<p>Last updated: {blapp.format.formatDate(terms.updated)}</p>
							} */}
						</div>
						{this.state.termsHistory &&
						<label>
							Seller Terms History:
							<select className="select select--tight l-margin-left--sm" selected={this.state.selectedTerms} onChange={(e) => this.getTerms(parseInt(e.target.value))}>
								{this.state.termsHistory.map((history, id) => (<option key={id} value={id}>{blapp.format.formatDate(history)}</option>))}
							</select>
						</label>
						}
					</header>
					<section className="l-pad--xl bg-color--pewter">
						{this.state.terms ?
						<div className="l-pad--xl bg-color--white l-border-round" dangerouslySetInnerHTML={{__html: this.state.terms.strContent}}/>
						:
						<div className="l-pad--xl bg-color--white l-border-round l-flex l-center-v">
							<i className="fas fa-spinner fa-spin"/>
						</div>
						}
					</section>
				</div>
			</div>
		);
	}

	getTermsHistory() {
		$.ajax({
			url: '/_ajax/getTermsHistory.ajax'
		,	method: 'GET'
		,	dataType: 'json'
		,	cache: false
		}).done(( data ) => { 
			if ( data.returnCode == "EC_OK" ) {
				this.setState({ termsHistory: data.result.reverse(), selectedTerms: 0 }, () => {
					this.getTerms(this.state.selectedTerms);
				});
			} else {
				alert( "Error while retrieving terms of service: " + data.returnCode  + ". Please refresh and try again.");
			}
		}).fail(() => {
			alert( "Error while retrieving terms of service. Please refresh and try again." );
		});
	}

	getTerms(id) {
		$.ajax({
			url: '/_ajax/getTermsContent.ajax'
		,	method: 'GET'
		,	data: { id: this.state.termsHistory.length - id - 1 }
		,	dataType: 'json'
		,	cache: false
		}).done(( data ) => { 
			if ( data.returnCode == "EC_OK" ) {
				this.setState({ selectedTerms: id, terms: data.result });
			} else {
				alert( "Error while retrieving terms of service: " + data.returnCode  + ". Please refresh and try again.");
			}
		}).fail(() => {
			alert( "Ajax Error!" );
		});
	}
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<TermsSeller blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-main' )
						);
		blapp.refs.register( "main", elem );
	}
);
